import type { ReactElement } from 'react';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { NavLink as NLink } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavLink } from 'reactstrap';
import BadgeList from 'atom-components/badge-list';
import RoleBadge from 'feature-components/badges/role-badge/role-badge';
import { useNotificationCount } from 'services/assist-api/entities/notification/check';
import { useAuthCustomer } from 'services/providers/auth.hooks';
import { useAuth } from 'services/providers/auth.provider';

export default function UserDropdown({ isIconOnly }: { isIconOnly?: boolean }): ReactElement {
  const { logout, me } = useAuth();
  const customer = useAuthCustomer();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = (): void => setDropdownOpen((prevState) => !prevState);
  const handleLogout = (): Promise<void> => logout();

  const notificationCount = useNotificationCount({ filters: { location: 'notification_centre' } });

  return (
    <>
      {!isIconOnly && customer?.name && <span className="sidebar-customer">{customer?.name}</span>}
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="end" className="w-100">
        <DropdownToggle
          color="info"
          caret={!isIconOnly}
          className={clsx('sidebar-user', { 'p-1': isIconOnly })}
        >
          <div className="user-icon">
            <FontAwesomeIcon icon="user" className="icon" />
          </div>
          {!isIconOnly && (
            <span className="user-details">
              {me?.firstname} {me?.lastname}
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu container={document.body} end>
          <DropdownItem header>Info</DropdownItem>
          <DropdownItem text>{customer?.name}</DropdownItem>
          <DropdownItem text>{me?.email}</DropdownItem>
          <DropdownItem text>
            <BadgeList>
              {me?.customerRoles?.map((role) => <RoleBadge key={role} role={role} />)}
            </BadgeList>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem header>Actions</DropdownItem>
          <DropdownItem>
            <NavLink to="/notifications" tag={NLink} className="m-0">
              <FontAwesomeIcon id="notifications" icon="bell" size="sm" className="fa-fw me-2" />
              Notifications
              {!!notificationCount.data && (
                <span className="badge bg-danger ms-2">
                  {notificationCount.data}
                  <span className="visually-hidden">unread notifications</span>
                </span>
              )}
            </NavLink>
          </DropdownItem>
          <DropdownItem>
            <NavLink to="/profile" tag={NLink} className="m-0">
              <FontAwesomeIcon icon="user" size="sm" className="fa-fw me-2" />
              Profile
            </NavLink>
          </DropdownItem>
          <DropdownItem>
            <NavLink href="#" onClick={handleLogout} className="m-0">
              <FontAwesomeIcon icon="arrow-right-from-bracket" size="sm" className="fa-fw me-2" />
              Sign Out
            </NavLink>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
}
